module.exports = __webpack_public_path__ + "static/media/react-native-1.23df46d7.svg";